import { App } from "@capacitor/app";
import { useRouter } from "vue-router";

export default function useAppUrlOpen() {
  const router = useRouter();

  void App.addListener("appUrlOpen", (data: { url: string }) => {
    onAppUrl(data.url);
  });

  void checkAppUrlOnLaunch();

  async function checkAppUrlOnLaunch() {
    if (await App.getLaunchUrl()) {
      const launchUrl = await App.getLaunchUrl();
      if (!launchUrl) {
        return;
      }

      onAppUrl(launchUrl.url);
    }
  }

  function onAppUrl(url: string) {
    if (!url.includes("://route--")) {
      return;
    }
    const fullRoute = url.split("://route--")[1];
    const route = fullRoute.split("?")[0];
    const params = new URLSearchParams(fullRoute.split("?")[1]);
    void router.push({
      name: route,
      query: Object.fromEntries(params as any)
    });
  }
}
